import React, { useState } from 'react'
import {
  Grid,
  Box,
  Typography,
} from "@mui/material";
import CustomButton from "../../Components/Button/Button";
import DropDown from '../../Components/Common/DropDown/DropDown';
import { useSelector,useDispatch } from 'react-redux';
import { DownloadArchivalExcelReport, GetAllEntitiesForUserAdmin } from '../../Reducers/dcoi';
import { useEffect } from 'react';
import "./ViewArchives.css";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Toster from "../../Components/Common/Toster/Toster";
function ViewArchives() {
  const dispatch = useDispatch();
  const[entity,setEntity]=useState();
  const[Years,setYears]=useState([]);
  const [message, setMessage] = useState();
  const [severity, setSeverity] = useState();
  const [alert, setAlert] = useState(false);


  useEffect(() => {
    dispatch(GetAllEntitiesForUserAdmin());
  }, []);


  const { AllEntitiesForUserAdmin, inProgress } = useSelector(
    (state) => state.dcoi
  );


  const yearOptions = Array.from({ length: 30 }, (_, i) => {
  const year = new Date().getFullYear() - i;
  return { id: year, Label: year.toString(),Value:year};
  });

  const handleYearChange = (selectedYears) => {
    setYears(selectedYears);
  };

  const handleSelectEntity = (selectedEntity)=>{
    setEntity(selectedEntity)
  }

  const handleDownloadReport = async()=>{
          if (!entity || !Years) return;
          await dispatch(DownloadArchivalExcelReport({
            "HFM":entity.join(","),
            "YEARS": Years.join(",")
          })).then((res) => {
          if (res?.payload?.status === 200) {
            const base64Data = res.payload.data.fileContent;
            const byteCharacters = atob(base64Data);
            const byteArrays = [];
            for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
              const slice = byteCharacters.slice(offset, offset + 1024);
              const byteNumbers = new Array(slice.length);
              for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
              }
              const byteArray = new Uint8Array(byteNumbers);
              byteArrays.push(byteArray);
            }
            const fileBlob = new Blob(byteArrays, { type: 'application/xlsx' });
            const fileURL = URL.createObjectURL(fileBlob);
            const link = document.createElement("a");
            link.href = fileURL;
            link.setAttribute("download",res.payload.data.fileName);
            document.body.appendChild(link);
            link.click();
            link.remove();
            setTimeout(() => {
              URL.revokeObjectURL(fileURL);
            }, 100);
            setAlert(true);
            setMessage("Report Downloaded Successfully");
            setSeverity("success");
          } else {
           setAlert(true);
           setMessage("Something Went Wrong")
           setSeverity("error");
         }
       }).catch((error) => {
         console.error("Error fetching file..:", error);
       });
  }


  return (<>
  <Toster message={message} severity={severity} alert={alert} setAlert={setAlert} />
  <Grid container mx={4} sx={{margin:"20px"}}>
  <LocalizationProvider dateAdapter={AdapterDayjs}>
    <Grid container spacing={2} sx={{ margin: "20px" }} alignItems="center">

      {/* Entity */}
      <Grid item xs={12} md={3} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Typography>
          <b>Entity:</b>
        </Typography>
        <Box sx={{ minWidth: 150, width: "250px" }}>
        <DropDown
          isMulti
          value={entity}
          options={AllEntitiesForUserAdmin}
          onChange={handleSelectEntity}
          sx={{minWidth:"250px"}}
        />
        </Box>
      </Grid>
      <Grid item xs={12} md={6} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Typography variant="body2" sx={{ whiteSpace: "nowrap" }}>
            <b>Years:</b>
          </Typography>
          <Box sx={{ minWidth: 150,width: "250px" }}>
          <DropDown
            isMulti
            value={Years}
            options={yearOptions}
            onChange={handleYearChange}
            placeholder="Select Years"
          />
        </Box>
      </Grid>

      {/* Button */}
      <Grid item xs={12} md={3}>
          <CustomButton label="Download Report" onClick={handleDownloadReport}   isDisabled={!entity || !Years || Years.length === 0}/>
      </Grid>

    </Grid>
  </LocalizationProvider>
  </Grid>
  </>)
}

export default ViewArchives